/*
 * @Author: zjw
 * @Date: 2021-06-10 15:46:43
 * @LastEditTime: 2023-04-04 17:25:45
 * @FilePath: \web-app\src\network\content\tag.js
 * @Environment: Vue + Element
 * @Description: 标签管理
 */
import { request } from "../request.js";

// 标签列表
export function tagList(data) {
	return request({
		url: "/web/back/sys/tag/list",
		method: "post",
		data,
	});
}

// 添加
export function addTag(data) {
	return request({
		url: "/web/back/sys/tag/insert",
		method: "post",
		data,
	});
}

// export function addTag(data) {
//     return request({
//         url:'/web/back/sys/tag/save',
//         method:'post',
//         data
//     })
// }

// 修改
export function editTag(data) {
	return request({
		url: "/web/back/sys/tag/update",
		method: "post",
		data,
	});
}

// 删除
export function delTag(data) {
	return request({
		url: "/web/back/sys/tag/delete" + "?id=" + data,
		method: "delete",
	});
}

// 批量删除
export function allDelTag(data) {
	return request({
		url: "/web/back/sys/tag/batch/delete",
		method: "delete",
		data,
	});
}

// 详情
export function detailTag(data) {
	return request({
		url: "/web/back/sys/tag/" + data,
		method: "get",
	});
}

// 标签分类列表
export function tagClassList(data) {
	return request({
		url: "/web/back/sys/tag-collection/list",
		method: "post",
		data,
	});
}
